<template>
  <b-container>
    <h1>Advisors</h1>

    <div class="box">
      <h3>Filters</h3>

      <b-row>
        <b-col cols="12" md="6">
          <b-form-group label="Experience">
            <b-form-checkbox-group
              name="experience" v-model="experience"
              :options="experienceOptions" :disabled="loading"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="Areas of Expertise">
            <b-form-checkbox-group
              name="expertise" v-model="expertise"
              :options="expertiseOptions" :disabled="loading"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <div class="table-responsive mb-4">
        <table class="table b-table table-bordered table-hover">
          <thead class="thead-light">
            <tr>
              <th>Name</th>
              <th>Experience</th>
              <th>Areas of Expertise</th>
              <th>Current Project</th>
              <th>Role</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="results.length === 0">
              <td class="text-center" colspan="6">
                <em>No advisors found!</em>
              </td>
            </tr>

            <tr v-for="user in results" :key="user.uuid">
              <td>
                <img
                  class="rounded-circle img-profile mr-2"
                  :src="user.avatar" :alt="`${user.first_name} ${user.last_name}`">
                {{ user.first_name }} {{ user.last_name }}
              </td>
              <td>
                {{
                  experienceOptions
                    .filter(el => el.value === user.experience)
                    .map(el => el ? el.text : '')[0]
                }}
              </td>
              <td>{{ expertiseFormat(user.expertise) }}</td>
              <td>{{ user.company_name }}</td>
              <td>{{ user.company_role }}</td>
              <td>
                <b-btn variant="primary" :to="`/user/${user.uuid}`" size="sm">
                  View Profile
                </b-btn>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-between align-items-center">
        <b-btn
          variant="secondary" size="sm"
          @click="setPage(page - 1)" :disabled="loading || page === 1"
        >
          Prev Page
        </b-btn>

        <span class="text-muted" v-if="!loading">
          Page {{ page }} of {{ totalPages }}
        </span>

        <span class="text-muted" v-if="loading">
          Loading
        </span>

        <b-btn
          variant="secondary" size="sm"
          @click="setPage(page + 1)" :disabled="loading || page === totalPages"
        >
          Next Page
        </b-btn>
      </div>
    </div>
  </b-container>
</template>

<script>
export default {
  name: 'UsersAdvisorsList',
  data () {
    return {
      loading: false,
      page: 1,
      totalPages: 0,
      experience: [],
      expertise: [],
      results: [],
      experienceOptions: [
        { text: '< 1 year', value: 'lt_1' },
        { text: '1-5 years', value: '1_5' },
        { text: '5-10 years', value: '5_10' },
        { text: '10-20 years', value: '10_20' },
        { text: '20+ years', value: '20p' }
      ],
      expertiseOptions: [
        { text: 'Finance', value: '1' },
        { text: 'Legal', value: '2' },
        { text: 'HR', value: '3' },
        { text: 'Strategy', value: '4' },
        { text: 'Ops', value: '5' },
        { text: 'Tech', value: '6' },
        { text: 'Mktg/Sales', value: '7' },
        { text: 'Buy/Sell', value: '8' },
        { text: 'Franch', value: '9' },
        { text: 'Intl', value: '10' },
        { text: 'Govt', value: '11' },
      ],
    }
  },
  mounted () {
    this.load()

    this.$skillsService.getSkillsAsValues(true)
      .then((skills) => {
        this.expertiseOptions = skills
      })
  },
  watch: {
    experience () {
      this.page = 1
      this.load()
    },
    expertise () {
      this.page = 1
      this.load()
    }
  },
  methods: {
    load () {
      this.loading = true
      this.$http
        .get('users/advisors', {
          params: {
            page: this.page,
            page_count: 25,
            sort_key: 'first_name',
            sort_order: 'ASC',
            experiences: this.experience,
            expertises: this.expertise,
          }
        })
        .then(
          (res) => {
            this.results = res.data.data
            this.totalPages = res.data.meta.last_page
          },
          () => {}
        )
        .finally(() => {
          this.loading = false
        })
    },
    expertiseFormat (expertises) {
      return expertises
        .map(e => e.title.split(' ')[0])
        .join(', ')
    },
    setPage (newPage) {
      this.page = newPage
      this.load()
      window.scrollTo(0,0)
    }
  }
}
</script>

<style scoped>
.img-profile { width: 24px; height: 24px; }
</style>
